<template>
    <div>
        <div class="row"
             style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <h5 class="center-align white-text">
                    Пользователи
                </h5>
                <div class="row"
                     style="margin-bottom: 0;">
                    <div class="input-field col s12 m8 l8 xl8">
                        <input id="first_name2"
                               type="text"
                               @keyup="search($event)"
                               class="white-text">
                        <label class="white-text"
                               for="first_name2">Search</label>
                    </div>
                    <div class="col s12 m4 l4 xl4 main">
                        <router-link
                                :to="'users/add'"
                                class="waves-effect waves-light btn indigo darken-3 btn-small"
                                style="width: 100%;"
                        >
                            <i class="material-icons left">add</i>
                            новый пользователь
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg centered">
                    <thead>
                    <tr>
                        <th>логин</th>
                        <th class="hide-on-small-and-down">включен</th>
                        <th class="hide-on-small-and-down">запись dvr</th>
                        <th class="hide-on-small-and-down">заметка</th>
                        <th>камеры</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="user.id"
                        data-id="users"
                        :data-search="user.login"
                        @click="getUser(user.login)"
                        v-for="user in users">
                        <td>{{user.login}}</td>
                        <td class="hide-on-small-and-down">
                            <i class="material-icons  darken-3"
                               :class="user.enabled ?  'green-text' : 'red-text'">
                                {{user.enabled ? "check_circle_outline" : "highlight_off"}}
                            </i>
                        </td>
                        <td class="hide-on-small-and-down">
                            <i class="material-icons  darken-3"
                               :class="user.dvr_allowed ?  'green-text' : 'red-text'">
                                {{user.dvr_allowed ? "check_circle_outline" : "highlight_off"}}
                            </i>
                        </td>
                        <td class="hide-on-small-and-down" width="200">
                            {{user.note}}
                        </td>
                        <td>
                            {{user.camera_count}}
                            <div class="btn indigo right waves-effect waves-light tooltips"
                                 data-tooltip="камеры пользователя"
                                 style="height: 30px;"
                                 @click.stop="$router.push(`/cameras/get/${user.login}/${getUsersType(user.note)}`)">
                                <i class="material-icons"
                                   style="position:relative; top: -2px;">playlist_play</i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapMutations} from "vuex";
    import {eventEmitter} from "../../main";
    import setRules from "../../assets/setRules";

    import Users from "../../plugins/controllers/users";

    export default {
        name: "Users",
        data() {
            return {
                users: []
            };
        },
        methods: {
            getApiData() {
                Users.getUsersList().then((response) => {
                    setRules(response);

                    console.log(response.data);

                    this.users = response.data;
                }).catch(e => {
                        this.setAuth(true);
                        this.setShowMenu(false);
                        console.log("Admins", e);
                        if (e.message.toLowerCase() === "network error") {
                            this.$toast.error({
                                title:   "Ошибка с соединением",
                                message: "Проблемы с интернет-подключением или с доступом к серверу"
                            });
                        } else {
                            this.$toast.error({
                                title:   "Произошла ошибка",
                                message: "Авторизуйтесь с вашей учетной записи"
                            });
                        }
                    })
                    .then(() => {
                        // preload.hidden();
                        if (!this.e) {
                            let elements = document.querySelectorAll(".tooltips");
                            this.e       = M.Tooltip.init(elements, {
                                position: "left"
                            });
                        }
                    });
            },
            //поиск в списке пользоветелей
            search(e) {
                let elements = document.querySelectorAll('[data-id="users"]');
                Array.from(elements).forEach(elem => {
                    if (
                        elem.attributes.getNamedItem("data-search").value.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
                    ) {
                        if (elem.classList.contains("hidden")) {
                            elem.classList.remove("hidden");
                        }
                    } else {
                        elem.classList.add("hidden");
                    }
                });
            },
            //роутинг на редактирование юзера
            getUser(login) {
                this.$router.push(`/users/get/${login}`);
                console.log(login);
            },
            getUsersType(data) {
                if (data === "user from Bugs") {
                    return "bugs";
                } else {
                    return "local";
                }
            },
            ...mapMutations([
                "setAuth",
                "setShowMenu"
            ]),
        },
        computed: {
            ...mapState(["tokenSuccess", "showLargePopup"]),

        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getApiData);
        },
        beforeDestroy() {
            if (this.e) {
                this.e.forEach(el => {
                    el.destroy();
                });
            }
            eventEmitter.$off("tokenSuccess", this.getApiData);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getApiData();
            } else {
                console.log("token is not success");
            }
            // preload.show();
        },
        watch: {
            '$route'(to, from) {
                if (this.tokenSuccess) {

                    console.log(localStorage.getItem("login"));
                    console.log(this.$route.params);

                    this.getApiData();

                } else {
                    console.log("token is not success");
                }
            }
        }
    }
</script>

<style scoped>
    .bold {
        font-weight: 500;
    }

    .main {
        margin-top: 15px;
    }

    @media screen and (max-width: 600px) {
        .main {
            margin: 0;
        }

        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    input[type=text]:not(.browser-default) {
        border-bottom: 1px solid #d0d0d0;
        box-shadow: 0 1px 0 #d0d0d0;
    }

    input[type="text"]:not(.browser-default):focus:not([readonly]) {
        border-bottom: 1px solid #f0e8f1;
        box-shadow: 0 1px 0 #dfd8df;
    }

    label.white-text {
        color: #d0d0d0 !important;

    &
    .active {
        color: #fff !important;
    }

    }

    .hidden {
        display: none;
    }

    input[type="text"] {

    &
    :not(.browser-default):focus:not([readonly]) + label {
        color: #fff;
    }

    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    tr {
        cursor: pointer;
    }

    tr th {
        cursor: default;
    }

    tr td:first-child {
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

</style>